import { useState } from 'react';
import { downloadLinks } from '@/mocks/data';

export default function DownloadSection() {
  const [activeTab, setActiveTab] = useState<'ios' | 'android'>('android');

  const iosSteps = [
    { step: '01', title: '打开App Store', desc: '在iPhone桌面找到并打开App Store应用商店' },
    { step: '02', title: '搜索应用', desc: '点击搜索标签，在搜索框中输入"黄瓜视频"' },
    { step: '03', title: '确认下载', desc: '找到官方应用，点击"获取"按钮开始下载' },
    { step: '04', title: '开始使用', desc: '安装完成后打开App，注册账号即可开始使用' },
  ];

  const androidSteps = [
    { step: '01', title: '访问官网', desc: '使用手机浏览器访问黄瓜视频官方网站下载页' },
    { step: '02', title: '下载APK', desc: '点击下载按钮，将APK安装包下载到手机本地' },
    { step: '03', title: '允许安装', desc: '在设置中允许"未知来源"应用安装权限' },
    { step: '04', title: '完成安装', desc: '点击安装包完成安装，打开App注册使用' },
  ];

  const steps = activeTab === 'ios' ? iosSteps : androidSteps;

  return (
    <section id="download" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            下载安装
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            快速下载黄瓜视频App
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[600px] mx-auto">
            支持iOS和Android双平台，选择你的设备开始下载
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <div className="flex items-center justify-center mb-10">
            <div className="inline-flex bg-background-200/70 rounded-full p-1">
              <button
                onClick={() => setActiveTab('ios')}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === 'ios'
                    ? 'bg-background-50 text-foreground-900'
                    : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-apple-fill"></i>
                </div>
                iOS版
              </button>
              <button
                onClick={() => setActiveTab('android')}
                className={`flex items-center gap-2 px-6 py-2.5 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  activeTab === 'android'
                    ? 'bg-background-50 text-foreground-900'
                    : 'text-foreground-600 hover:text-foreground-800'
                }`}
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-android-fill"></i>
                </div>
                Android版
              </button>
            </div>
          </div>

          <div className="space-y-4">
            {steps.map((item, index) => (
              <div
                key={item.step}
                className="flex items-start gap-4 p-5 bg-background-50 rounded-xl border border-background-200/70"
              >
                <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center flex-shrink-0 rounded-xl bg-primary-100 text-primary-600 font-bold text-sm md:text-base">
                  {item.step}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base font-heading font-bold text-foreground-900 mb-1">
                    {item.title}
                  </h4>
                  <p className="text-sm text-foreground-600">{item.desc}</p>
                </div>
                {index < steps.length - 1 && (
                  <div className="hidden sm:flex items-center justify-center flex-shrink-0 w-8 h-full">
                    <div className="w-0.5 h-full bg-background-200"></div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-10">
            <a
              href={activeTab === 'ios' ? downloadLinks.ios : downloadLinks.android}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-download-line text-lg"></i>
              </div>
              立即下载{activeTab === 'ios' ? 'iOS' : 'Android'}版
            </a>
            <p className="text-xs text-foreground-500 mt-3">
              当前最新版本：v5.8.0 · 更新日期：2026年8月
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}